import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-custom-tooltip',
    templateUrl: './custom-tooltip.component.html',
    styleUrls: ['./custom-tooltip.component.scss'],
    standalone: false
})
export class CustomTooltipComponent implements OnInit {

  data: any;

  constructor(
  ) { }

  ngOnInit() {
  }

}

